/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWarningOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#961E1E"
      d="M19.988 21.666H4.012a2.237 2.237 0 0 1-2.152-1.603 2.22 2.22 0 0 1 .174-1.711l7.983-14.836a2.255 2.255 0 0 1 3.966 0l7.987 14.836c.178.328.268.693.268 1.068 0 .6-.235 1.168-.662 1.59a2.21 2.21 0 0 1-1.588.656Zm-15.976-1.5h15.98c.202 0 .39-.08.53-.22a.744.744 0 0 0 .131-.887L12.661 4.23A.733.733 0 0 0 12 3.833a.733.733 0 0 0-.661.394L3.352 19.064a.738.738 0 0 0-.057.572.744.744 0 0 0 .361.445c.108.057.23.085.356.085Z"
    />
    <path
      fill="#961E1E"
      d="M12 15.628a.751.751 0 0 1-.75-.713l-.267-5.718v-.038a1.016 1.016 0 0 1 1.008-1.026h.056c.562.023.998.501.97 1.064l-.267 5.719a.751.751 0 0 1-.75.712ZM12 18.619a.94.94 0 0 1-.938-.938.94.94 0 0 1 .938-.937.94.94 0 0 1 .937.937.94.94 0 0 1-.937.938Z"
    />
  </svg>
);

export default SvgWarningOutline;
